<template>
  <div class="card" :class="{ 'no-shadow': noShadow }" :style="{ padding }">
    <!-- @slot This contains the content of the card -->
    <slot></slot>
  </div>
</template>

<script>
/**
 * This provides the card layout.
 * This component provides that flexibility to control padding around the card
 */
export default {
  name: 'Card',
  props: {
    padding: {
      default: '25px'
    },
    noShadow: Boolean
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.card {
  padding: 25px;
  border-radius: 5px;
  background-color: $documentColor;
  &:not(.no-shadow) {
    box-shadow: $cardShadow;
  }
}
</style>
